<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
  <g>
    <path class="cls-3" d="m77.1,16.91v8.09H12.9v-8.09c0-2.2,1.8-4,4.01-4h56.17c2.21,0,4.01,1.8,4.01,4Z"/>
    <path class="cls-3" d="m78.24,26.14H11.76v-9.23c0-2.84,2.31-5.15,5.15-5.15h56.17c2.84,0,5.15,2.31,5.15,5.15v9.23Zm-64.19-2.29h61.9v-6.94c0-1.58-1.28-2.86-2.86-2.86H16.91c-1.58,0-2.86,1.28-2.86,2.86v6.94Z"/>
  </g>
  <path class="cls-4" d="m73.09,78.24H16.91c-2.84,0-5.15-2.31-5.15-5.15V23.85h66.48v49.24c0,2.84-2.31,5.15-5.15,5.15ZM14.05,26.14v46.95c0,1.58,1.28,2.86,2.86,2.86h56.17c1.58,0,2.86-1.28,2.86-2.86V26.14H14.05Z"/>
  <rect class="cls-4" x="54.55" y="24.99" width="2.29" height="52.1"/>
  <rect class="cls-4" x="33.16" y="24.99" width="2.29" height="52.1"/>
  <g>
    <line class="cls-2" x1="12.9" y1="42.36" x2="77.1" y2="42.36"/>
    <rect class="cls-4" x="12.9" y="41.22" width="64.19" height="2.29"/>
  </g>
  <g>
    <line class="cls-2" x1="12.9" y1="59.73" x2="77.1" y2="59.73"/>
    <rect class="cls-4" x="12.9" y="58.58" width="64.19" height="2.29"/>
  </g>
  <g>
    <circle class="cls-1" cx="45" cy="51.05" r="16.42"/>
    <path class="cls-2" d="m45,68.61c-9.69,0-17.57-7.88-17.57-17.57s7.88-17.57,17.57-17.57,17.57,7.88,17.57,17.57-7.88,17.57-17.57,17.57Zm0-32.84c-8.42,0-15.27,6.85-15.27,15.27s6.85,15.27,15.27,15.27,15.27-6.85,15.27-15.27-6.85-15.27-15.27-15.27Z"/>
  </g>
  <path class="cls-2" d="m45,40.09c-.16,0-.29-.13-.29-.29v-2.5c0-.16.13-.29.29-.29s.29.13.29.29v2.5c0,.16-.13.29-.29.29Z"/>
  <g>
    <line class="cls-1" x1="35.28" y1="41.33" x2="36.23" y2="42.28"/>
    <path class="cls-2" d="m36.23,42.56c-.07,0-.15-.03-.2-.08l-.95-.95c-.11-.11-.11-.29,0-.4s.29-.11.4,0l.95.95c.11.11.11.29,0,.4-.06.06-.13.08-.2.08Z"/>
  </g>
  <g>
    <line class="cls-1" x1="31.26" y1="51.05" x2="33.76" y2="51.05"/>
    <path class="cls-2" d="m33.76,51.33h-2.5c-.16,0-.29-.13-.29-.29s.13-.29.29-.29h2.5c.16,0,.29.13.29.29s-.13.29-.29.29Z"/>
  </g>
  <g>
    <line class="cls-1" x1="35.69" y1="60.35" x2="36.64" y2="59.4"/>
    <path class="cls-2" d="m35.69,60.64c-.07,0-.15-.03-.2-.08-.11-.11-.11-.29,0-.4l.95-.95c.11-.11.29-.11.4,0s.11.29,0,.4l-.95.95c-.06.06-.13.08-.2.08Z"/>
  </g>
  <g>
    <line class="cls-1" x1="45" y1="64.78" x2="45" y2="62.29"/>
    <path class="cls-2" d="m45,65.07c-.16,0-.29-.13-.29-.29v-2.5c0-.16.13-.29.29-.29s.29.13.29.29v2.5c0,.16-.13.29-.29.29Z"/>
  </g>
  <g>
    <line class="cls-1" x1="54.31" y1="60.35" x2="53.36" y2="59.4"/>
    <path class="cls-2" d="m54.31,60.64c-.07,0-.15-.03-.2-.08l-.95-.95c-.11-.11-.11-.29,0-.4s.29-.11.4,0l.95.95c.11.11.11.29,0,.4-.06.06-.13.08-.2.08Z"/>
  </g>
  <g>
    <line class="cls-1" x1="58.74" y1="51.05" x2="56.24" y2="51.05"/>
    <path class="cls-2" d="m58.74,51.33h-2.5c-.16,0-.29-.13-.29-.29s.13-.29.29-.29h2.5c.16,0,.29.13.29.29s-.13.29-.29.29Z"/>
  </g>
  <g>
    <line class="cls-1" x1="54.31" y1="41.33" x2="53.36" y2="42.28"/>
    <path class="cls-2" d="m53.36,42.57c-.07,0-.15-.03-.2-.08-.11-.11-.11-.29,0-.4l.95-.95c.11-.11.29-.11.4,0s.11.29,0,.4l-.95.95c-.06.06-.13.08-.2.08Z"/>
  </g>
  <g>
    <line class="cls-1" x1="31.26" y1="51.05" x2="33.76" y2="51.05"/>
    <path class="cls-2" d="m33.76,51.33h-2.5c-.16,0-.29-.13-.29-.29s.13-.29.29-.29h2.5c.16,0,.29.13.29.29s-.13.29-.29.29Z"/>
  </g>
  <g>
    <line class="cls-1" x1="45" y1="64.78" x2="45" y2="62.29"/>
    <path class="cls-2" d="m45,65.07c-.16,0-.29-.13-.29-.29v-2.5c0-.16.13-.29.29-.29s.29.13.29.29v2.5c0,.16-.13.29-.29.29Z"/>
  </g>
  <g>
    <line class="cls-1" x1="58.74" y1="51.05" x2="56.24" y2="51.05"/>
    <path class="cls-2" d="m58.74,51.33h-2.5c-.16,0-.29-.13-.29-.29s.13-.29.29-.29h2.5c.16,0,.29.13.29.29s-.13.29-.29.29Z"/>
  </g>
  <g>
    <polyline class="cls-1" points="41.58 42.36 45 51.05 53.83 55.13"/>
    <path class="cls-4" d="m53.83,55.99c-.12,0-.24-.03-.36-.08l-9.14-4.23-3.55-9c-.17-.44.04-.94.48-1.11.44-.17.94.04,1.11.48l3.3,8.36,8.52,3.94c.43.2.62.71.42,1.14-.15.31-.46.5-.78.5Z"/>
  </g>
</svg>
</template>

<script>
export default {
    name: "TimePerformanceTableIcon",
}
</script>

<style scoped>
      .cls-1 {
        fill: #fff;
      }

      .cls-2 {
        fill: #0f5b71;
      }

      .cls-3 {
        fill: #115c72;
      }

      .cls-4 {
        fill: #59c5c7;
      }
    </style>